import * as React from 'react'
import Title from '../titlte/Title'

interface ImprintProps {}

const Imprint: React.SFC<ImprintProps> = ({}) => {
  return (
    <div style={{ padding: 16, color: 'rgb(70, 70, 70)' }}>
      <Title size="32px">Impressum</Title>
      <address>
        <strong>Peerigon GmbH</strong>
        <br />
        Werner-von-Siemens-Straße 6<br />
        Gebäude 9<br />
        86159 Augsburg
        <br />
        Germany
      </address>
      <ul>
        <li>
          Es gilt das <a href="https://peerigon.com/de/kontakt">Impressum der Peerigon GmbH</a>.
        </li>
        <li>
          Es gilt die <a href="https://peerigon.com/de/datenschutz">Datenschutzerklärung der Peerigon GmbH</a>.
        </li>
      </ul>
      <Title size="20px">Copyright Informationen</Title>
      <ul>
        <li>
          <a href="https://www.freepik.com/free-vector/ecosystem-concept-with-city_2739756.htm">
            ecosystem-concept-with-city Designed by Freepik
          </a>
        </li>
        <li>
          <div>
            Icons made by{' '}
            <a href="https://www.freepik.com/" title="Freepik">
              Freepik
            </a>{' '}
            from{' '}
            <a href="https://www.flaticon.com/" title="Flaticon">
              www.flaticon.com
            </a>{' '}
            is licensed by{' '}
            <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">
              CC 3.0 BY
            </a>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default Imprint



// WEBPACK FOOTER //
// ./src/components/routes/Imprint.tsx